import { all } from 'redux-saga/effects';

import { sagas as portfolioSagas } from './sagas/portfolioSagas';
import { sagas as resumeSagas } from './sagas/resumeSagas';

export default function* rootSaga() {
  yield all([...portfolioSagas, ...resumeSagas]);
}
